module.exports = __webpack_public_path__ + "img/bgDecorate.7f6d41dd.png";